import { default as React, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { LoadingButton } from '@mui/lab';
// import ExportCsv from '../Utils/ExportCsv.js';

import FilterListIcon from '@mui/icons-material/FilterList'
import FilterListOffIcon from '@mui/icons-material/FilterListOff'
import AddIcon from '@mui/icons-material/Add'
import HelpIcon from '@mui/icons-material/Help'
import RestoreIcon from '@mui/icons-material/Restore'

export default function ListViewCommandBar (props = {}) {
  const navigate = useNavigate()
  const [isFilterVisible, setIsFilterVisible] = useState(true)

  const toggleFilters = () => {
    props.toggleFilters()
    //props.listView.toggleFilters()
    setIsFilterVisible(!isFilterVisible)
  }

  const toggleHelp = () => {
    navigate(props.helpPage)
  }

  return (
    <div className="tis-commandbar tis-commandbar-listview">
      {props.helpPage && <LoadingButton loading={props.loading} onClick={toggleHelp}><HelpIcon/></LoadingButton>}
      {/* {(typeof this.props.showExport === 'undefined' || this.props.showExport) && <Button bsSize="small" onClick={() => {
        this.state.listView.exportData();
      }}>Export&nbsp;&nbsp;<Glyphicon glyph="download" bsSize="small"/></Button>} */}
      {(props.showFilters === undefined || props.showFilters) && <LoadingButton loading={props.loading} variant="contained" onClick={toggleFilters}>{isFilterVisible ? <FilterListIcon/> : <FilterListOffIcon/>}</LoadingButton>}
      {/* {(props.showAdd === undefined || props.showAdd) && props.listView && <Link to={props.listView.getAddItemUrl()}>
        <Button variant="outlined">Add&nbsp;&nbsp;<AddIcon/></Button>
      </Link>} */}
      {(props.showAdd === undefined || props.showAdd) && <LoadingButton loading={props.loading} variant="outlined" onClick={props.addRecord}>Add&nbsp;&nbsp;<AddIcon/></LoadingButton>}
      {(props.showResetList) && <LoadingButton loading={props.loading} variant="contained" onClick={props.onClickReset}>Reset Table&nbsp;&nbsp;<RestoreIcon/></LoadingButton>}
      {props.showShare && props.share}


    </div>
  )
}
